'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, toast } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: 'group toast bg-cyan-300 text-slate-900 border border-cyan-400 shadow-lg',
          description: 'group-[.toast]:text-slate-800',
          actionButton: 'group-[.toast]:bg-cyan-600 group-[.toast]:text-white',
          cancelButton: 'group-[.toast]:bg-cyan-200 group-[.toast]:text-slate-900',
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
